import Config from '@config';
import { PicSearchData, PicTypeRuleAirtable } from '@typings';
import { mapRuleRecord, mapStateConfigRecord } from '@utils/pic-search-mappers';
import Airtable from 'airtable';

const base = new Airtable({ apiKey: Config.AIRTABLE_API_KEY }).base(Config.AIRTABLE_BASE_ID);

export const fetchPicSearchData = async (): Promise<PicSearchData[]> => {
    try {
        const [pictypeRulesRecords, stateConfigRecords] = await Promise.all([
            base('Pictype_Rules')
                .select({
                    filterByFormula: '{Active} = TRUE()',
                    sort: [{ field: 'Priority', direction: 'asc' }],
                })
                .all(),
            base('State_Configuration')
                .select({
                    filterByFormula: '{Active} = TRUE()',
                    sort: [{ field: 'Priority', direction: 'asc' }],
                })
                .all(),
        ]);

        const rulesMap = new Map<string, PicTypeRuleAirtable>();
        pictypeRulesRecords.forEach((record) => {
            const rule = mapRuleRecord(record);
            if (rule) {
                rulesMap.set(record.id, rule); // use Airtable record.id
            }
        });

        return stateConfigRecords.map((record) => mapStateConfigRecord(record, rulesMap));
    } catch (error) {
        console.error('Airtable fetch error:', error);
        throw new Error(
            `Failed to fetch data from Airtable: ${error instanceof Error ? error.message : 'Unknown error'}`
        );
    }
};
